import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MonthEntry } from 'src/app/api/models/MonthEntry';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import {
  startOfMonth, endOfMonth, addMonths, getYear, getMonth,
  isSameMonth, isAfter, isBefore, format,
} from 'date-fns';
import { pt } from 'date-fns/locale';

registerLocaleData(localePt);

@Component({
    selector: 'app-date-selection-dialog',
    templateUrl: './date-selection-dialog.component.html',
    styleUrls: ['./date-selection-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DateSelectionDialogComponent {
  months: MonthEntry[] = [];
  selectedMonth: Date;

  constructor(
    public dialogRef: MatDialogRef<DateSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      currentDate: Date;
      minDate: Date;
      maxDate: Date;
      entregaNumber: number;
    }
  ) {
    this.selectedMonth = this.data.currentDate;
    this.generateMonths();
  }

  hasSelectedMonth(): boolean {
    return this.months.some(m => m.isSelected);
  }

  selectMonth(month: MonthEntry) {
    if (!month.isAvailable) return;

    // Clear previous selection
    this.months.forEach(m => {
      m.isSelected = false;
      m.isPreviousSelection = m.date.getTime() === this.data.currentDate.getTime();
    });

    // Set new selection and ensure UTC midnight
    month.isSelected = true;
    this.selectedMonth = new Date(Date.UTC(month.date.getFullYear(), month.date.getMonth(), 1));
  }

  private generateMonths() {
    const start = startOfMonth(this.data.minDate);
    const end = endOfMonth(this.data.maxDate);

    let current = new Date(start);
    while (!isAfter(current, end)) {
      const utcDate = new Date(Date.UTC(getYear(current), getMonth(current), 1));

      this.months.push({
        date: utcDate,
        month: format(current, 'MMM', { locale: pt }),
        year: getYear(current),
        isSelected: isSameMonth(current, startOfMonth(this.selectedMonth)),
        isPreviousSelection: isSameMonth(current, this.data.currentDate),
        isAvailable: !isBefore(current, start) && !isAfter(current, end)
      });

      current = addMonths(current, 1);
    }
  }

  confirmSelection(): void {
    const selectedMonth = this.months.find(m => m.isSelected);
    if (selectedMonth) {
      // Ensure UTC midnight when confirming selection
      const utcDate = new Date(Date.UTC(selectedMonth.date.getFullYear(), selectedMonth.date.getMonth(), 1));
      this.dialogRef.close(utcDate);
    }
  }

  cancel() {
    this.dialogRef.close();
  }
}
